<template>
    <b-modal
        id="ModalCreateDataselection"
        size="xl"
        title="Ajouter une sélection de donnée"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        hide-footer
    >
        <FormDataselection
            v-bind:projectId="projectId"
            v-bind:datasource="datasource"
            @saved="onSaved"
            class="mb-4"
        />
    </b-modal>
</template>
<script>
import FormDataselection from "@/components/model/dataselection/FormDataselection";
export default {
    components: {
        FormDataselection,
    },
    props: {
        projectId: {
            required: true,
            type: [String, Number],
        },
        datasource: {
            required: true,
            type: Object,
        },
    },
    methods: {
        onSaved() {
            this.$bvModal.hide("ModalCreateDataselection");
            this.$emit("saved");
        },
    },
};
</script>
